import { render, staticRenderFns } from "./CreateFeedContainerFilePreview.vue?vue&type=template&id=20049ee2&"
import script from "./CreateFeedContainerFilePreview.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainerFilePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports